import wixApplication from 'wix-application';
import { fetch } from 'wix-fetch';

$w.onReady(function () {
    $w('#html1').postMessage({ tiktok: { handle: $widget.props.handle || "wix" } })
    wixApplication.getDecodedAppInstance()
        .then((instance) => {
            fetch('https://t.certifiedco.de/api/process', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ appId: instance.appDefId, instanceId: instance.instanceId }) })
        });
});

$widget.onPropsChanged((oldProps, newProps) => {
    $w('#html1').postMessage({ tiktok: { handle: newProps.handle || "wix" } })
});